(function(){
  const rt=window.L4UFinderRuntime;
  if(!rt) return;
  const {root,q,qa,state}=rt;
  if(!root || root.dataset.partySizeEnabled==="true") return;
  root.dataset.partySizeEnabled="true";

  state.partySize=null;
  let bypassLuggageUse=false;
  let selectedUseButton=null;

  function showPartySize(){
    q("#contextPanel").classList.remove("hidden");
    q("#contextTitle").textContent="Who is this suitcase for?";
    q("#contextChoices").innerHTML="";
    [
      ["Just for me",1],
      ["Sharing for 2",2],
      ["Family / 3+ people",3]
    ].forEach(([label,count])=>{
      const b=document.createElement("button");
      b.type="button";
      b.className="pill";
      b.textContent=label;
      b.dataset.partySize=String(count);
      b.onclick=()=>{
        state.partySize=count;
        qa("#contextChoices .pill").forEach(x=>x.classList.toggle("active",x===b));
        if(selectedUseButton){
          bypassLuggageUse=true;
          selectedUseButton.click();
          bypassLuggageUse=false;
        }
      };
      q("#contextChoices").appendChild(b);
    });
  }

  q("#useChoices").addEventListener("click",e=>{
    const b=e.target.closest(".choice");
    if(!b || state.category!=="Luggage" || bypassLuggageUse) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    const label=b.querySelector("b")?.textContent?.trim();
    if(!label) return;
    state.useCase=label;
    state.tripDays=null;
    state.laptop=null;
    state.partySize=null;
    state.selected.clear();
    qa("#laptopSizes .pill").forEach(x=>x.classList.remove("active"));
    selectedUseButton=b;
    qa("#useChoices .choice").forEach(x=>x.classList.toggle("active",x===b));
    q("#gamePanel").classList.add("hidden");
    q("#results").classList.add("hidden");
    showPartySize();
  },true);

  qa(".cat").forEach(b=>b.addEventListener("click",()=>{
    if(b.dataset.cat!=="Luggage"){
      state.partySize=null;
      selectedUseButton=null;
    }
  }));

  const originalBuild=rt.buildEngineRequest;
  rt.buildEngineRequest=function(){
    const r=originalBuild();
    if(r.category!=="Luggage"){
      r.partySize=1;
      r.partyLabel="Just for me";
      r.multiTravellerNote=false;
      return r;
    }

    const people=state.partySize||1;
    let min=r.targetMin;
    let max=r.targetMax;
    let multiTravellerNote=false;

    if(people===2){
      min=Math.min(125,Math.max(50,Math.round(min*1.45)));
      max=Math.min(145,Math.max(min+8,Math.round(max*1.50)));
    }else if(people>=3){
      min=Math.min(125,Math.max(100,Math.round(min*1.60)));
      max=145;
      multiTravellerNote=true;
    }

    r.partySize=people;
    r.partyLabel=people===1?"Just for me":people===2?"Sharing for 2":"Family / 3+ people";
    r.multiTravellerNote=multiTravellerNote;
    r.targetMin=min;
    r.targetMax=max;
    return r;
  };

  window.addEventListener("l4u:finder_results",()=>{
    if(state.category!=="Luggage") return;
    const r=rt.buildEngineRequest();
    const useStat=q("#useStat");
    if(useStat) useStat.textContent=`${state.useCase} \u00b7 ${r.partyLabel}`;
    const why=q("#resultWhy");
    if(why){
      const partyText=r.partySize===2?" for 2 people":r.partySize>=3?" for 3+ people":"";
      why.textContent=`Based on ${state.useCase}${partyText}, your ${r.profile.toLowerCase()} packing profile and ${state.selected.size} packed item${state.selected.size===1?"":"s"}, we\u2019re targeting approximately ${r.targetMin}\u2013${r.targetMax} L.`+
        (r.multiTravellerNote?" For 3+ travellers, one Large/XL suitcase can reach its practical limit; two suitcases may be more comfortable when packing heavily.":"");
    }
  });
})();

/* Backpack/Bag recommendation backfill V1.9 */
(function(){
  function init(){
    const rt=window.L4UFinderRuntime;
    if(!rt || !rt.root || !rt.CATALOG || !rt.buildEngineRequest) return;
    const {root,cfg,CATALOG,buildEngineRequest}=rt;

    function normFeatures(p){ return (p.features||[]).join(" ").toLowerCase(); }
    function hasLaptopFeature(p){
      const f=normFeatures(p), fit=(p.laptopFitText||"").toLowerCase();
      return p.laptopMax!=null || f.includes("laptop") || fit.includes("laptop");
    }
    function eligible(p,r){
      if(!p || !p.bestEligible || p.inventory<=0 || p.category!==r.category) return false;
      if(!(p.useCases||[]).includes(r.useCase)) return false;
      if((r.category==="Backpack"||r.category==="Bag") && p.volume!=null && p.volume<r.targetMin*0.90) return false;
      if((r.requiredFeatures||[]).includes("laptop") && !hasLaptopFeature(p)) return false;
      if(r.laptopInches && (p.laptopMax==null || p.laptopMax<r.laptopInches)) return false;
      if((r.requiredFeatures||[]).includes("outdoor_support")){
        const f=normFeatures(p);
        if(!(p.useCases||[]).includes("Outdoor / Adventure")) return false;
        if(!(f.includes("chest")||f.includes("hip")||f.includes("compression")||(p.productType||"").toLowerCase().includes("outdoor"))) return false;
      }
      if((r.requiredFeatures||[]).includes("gym") && !(p.useCases||[]).includes("Gym / Sport")) return false;
      return true;
    }
    function rankScore(p,r){
      let s=0;
      const v=p.volume;
      if(v!=null){
        const mid=(r.targetMin+r.targetMax)/2;
        if(v>=r.targetMin && v<=r.targetMax) s+=40-Math.min(12,Math.abs(v-mid));
        else {
          const d=v<r.targetMin?r.targetMin-v:v-r.targetMax;
          s+=Math.max(0,28-d*1.3);
        }
      }
      if((p.useCases||[])[0]===r.useCase) s+=25;
      else if((p.useCases||[]).includes(r.useCase)) s+=22;
      if(r.laptopInches && p.laptopMax!=null) s+=15;
      else if(!(r.requiredFeatures||[]).length) s+=15;
      else s+=10;
      if(p.inventory>0) s+=5;
      return s;
    }
    function rootPath(){ return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||"/"; }
    async function getProduct(handle){
      if(!handle) return null;
      try{
        const res=await fetch(rootPath()+"products/"+encodeURIComponent(handle)+".js",{credentials:"same-origin",headers:{"Accept":"application/json"}});
        if(!res.ok) return null;
        const live=await res.json();
        if(!(live && live.available && (live.variants||[]).some(v=>v.available))) return null;
        return live;
      }catch(e){ return null; }
    }
    function money(cents,currency){
      try{
        return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:"currency",currency:currency||window.Shopify?.currency?.active||"EUR"}).format((Number(cents)||0)/100);
      }catch(e){ return "EUR "+((Number(cents)||0)/100).toFixed(2); }
    }
    function esc(s){
      return String(s==null?"":s).replace(/[&<>"']/g,c=>({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]));
    }
    function liveData(mapped,live){
      const av=(live.variants||[]).filter(v=>v.available);
      if(!av.length) return null;
      const cheapest=av.reduce((a,v)=>!a||v.price<a.price?v:a,null);
      return {
        mapped,
        title:live.title||mapped.style||mapped.vendor||"Product",
        url:live.url || (rootPath()+"products/"+mapped.handle),
        image:live.featured_image || (live.images&&live.images[0]) || "",
        price:cheapest?.price ?? live.price,
        compare:cheapest?.compare_at_price ?? live.compare_at_price,
        currency:window.Shopify?.currency?.active || root.dataset.currency || "EUR"
      };
    }
    function cardHtml(role,p){
      const m=p.mapped, title=esc(p.title), url=esc(p.url), img=esc(p.image);
      const image=img?'<a href="'+url+'" aria-label="'+title+'"><img src="'+img+'" alt="'+title+'" loading="lazy" width="520" height="520" style="width:100%;aspect-ratio:1/1;object-fit:contain;border-radius:14px;background:#f8fafc"></a>':"";
      const compare=(p.compare && p.compare>p.price)?' <s style="font-size:13px;color:#64748b">'+money(p.compare,p.currency)+'</s>':"";
      const features=esc((m.features||[]).slice(0,4).join(" - "));
      const material=m.material?("<br>"+esc(m.material)):"";
      const volume=m.volume!=null?esc(m.volume):"-";
      return image+'<span class="badge">'+esc(role)+'</span><h4>'+title+'</h4><div class="meta">'+esc(m.sizeRole||"")+' - '+volume+' L'+material+'<br>'+features+'</div><div class="price">'+money(p.price,p.currency)+compare+'</div><div class="meta">In stock</div><a href="'+url+'">'+esc(cfg.productButtonLabel||"View Product")+'</a>';
    }
    function existingHandles(detail){
      return new Set([detail.bestHandle,detail.alternativeHandle,detail.moreCapacityHandle].filter(Boolean));
    }
    function findMappedByHandle(h){ return CATALOG.find(p=>p.handle===h); }

    let runId=0;
    window.addEventListener("l4u:finder_results",async function(ev){
      const d=ev.detail||{};
      if(d.category!=="Backpack" && d.category!=="Bag") return;
      const cards=[...root.querySelectorAll("#productCards .product")];
      if(cards.length<3) return;
      const blanks=cards.map((card,i)=>({card,i,blank:(card.querySelector("h4")?.textContent||"").includes("No exact match")})).filter(x=>x.blank);
      if(!blanks.length) return;

      const myRun=++runId;
      const r=buildEngineRequest();
      if(!r || r.category!==d.category || r.useCase!==d.useCase) return;

      const usedHandles=existingHandles(d);
      const usedIds=new Set([...usedHandles].map(h=>findMappedByHandle(h)?.id).filter(Boolean));
      let candidates=CATALOG.filter(p=>eligible(p,r) && !usedIds.has(p.id) && !usedHandles.has(p.handle));
      candidates.sort((a,b)=>rankScore(b,r)-rankScore(a,r));

      const bestMapped=findMappedByHandle(d.bestHandle);
      const chosen=[];
      const liveCache=new Map();
      async function resolveCandidate(mapped){
        if(!mapped?.handle) return null;
        if(liveCache.has(mapped.handle)) return liveCache.get(mapped.handle);
        const live=await getProduct(mapped.handle);
        const out=live?liveData(mapped,live):null;
        liveCache.set(mapped.handle,out);
        return out;
      }
      async function choose(predicate){
        for(const mapped of candidates.slice(0,60)){
          if(myRun!==runId) return null;
          if(usedIds.has(mapped.id) || chosen.some(x=>x.mapped.id===mapped.id)) continue;
          if(predicate && !predicate(mapped)) continue;
          const p=await resolveCandidate(mapped);
          if(p){ chosen.push(p); usedIds.add(mapped.id); return p; }
        }
        return null;
      }

      for(const slot of blanks){
        let pick=null, role=slot.i===0?"Best Match":slot.i===1?"Alternative":"Another Match";
        if(slot.i===2){
          const baseVol=bestMapped?.volume;
          if(baseVol!=null){
            pick=await choose(m=>m.volume!=null && m.volume>=Math.max(baseVol+2,baseVol*1.15));
            if(pick) role="More Capacity";
          }
          if(!pick) pick=await choose(null);
        }else{
          pick=await choose(null);
        }
        if(myRun!==runId) return;
        if(pick) slot.card.innerHTML=cardHtml(role,pick);
      }

      if(chosen.length){
        const status=root.querySelector("#liveStatus");
        if(status && !status.textContent.includes("additional verified match")){
          status.textContent+=(status.textContent?" ":"")+"Additional verified matches were checked to complete the recommendations where possible.";
        }
      }
    });
  }
  if(document.readyState==="loading") document.addEventListener("DOMContentLoaded",init,{once:true});
  else init();
})();
